import { contains, equals, prop } from "ramda";
import { camelizeKeys } from "humps";
import { STORE_BUCKET, ORDERS_URL } from "api_urls";
import { getPrettyUrl } from "get_base_uri";
import { checkStatus, parseJSON, cloudfrontGetRequest, getRequest, } from "helpers/ajax_request";
import getEnv from "helpers/get_env";
import { formatMenu } from "helpers/transforms/online_ordering/menu_transform";
export function getItemStockLevelInfo() {
    return fetch(ORDERS_URL + "/" + getPrettyUrl() + "/items", getRequest())
        .then(checkStatus)
        .then(parseJSON)
        .catch(function (ex) {
        if (equals(getEnv(), "development")) {
            var CHROME_EXCEPTION = "Failed to fetch:";
            var FF_EXCEPTION = "NetworkError when attempting to fetch resource";
            if (contains(CHROME_EXCEPTION, ex.message) ||
                contains(FF_EXCEPTION, ex.message)) {
                return {};
            }
            console.log("failed stock level request for local development: " + ex.message);
        }
        throw ex;
    });
}
function getOrderingInfo() {
    return fetch(STORE_BUCKET + "/" + getPrettyUrl() + "/menu.json", cloudfrontGetRequest())
        .then(checkStatus)
        .then(parseJSON)
        .then(camelizeKeys)
        .then(function (data) { return prop("menu", data); })
        .then(formatMenu);
}
export default getOrderingInfo;
